import { composeReducers } from 'common/util';
import lodash from 'lodash';

import {
    LOAD_STUDY_ROLES,
    ADD_STUDY_ROLE,
} from 'pages/delegationOfAuthority/actions/studyRoles';

export function loadStudyRoles(state, action) {
    if (!action || action.type !== LOAD_STUDY_ROLES) {
        return state;
    }
    return {
        ...state,
        doaRoles: action.payload,
    };
}

export function addStudyRole(state, action) {
    if (!action || action.type !== ADD_STUDY_ROLE) {
        return state;
    }

    if (lodash.isNil(action.payload) || lodash.isEmpty(action.payload)) {
        return state;
    }

    const existingRoles = lodash.get(state, 'doaRoles', []);
    const newRole = {
        id: action.payload.id,
        name: action.payload.name,
        isSystem: action.payload.isSystem,
    };

    existingRoles.push(newRole);

    const nonSystemRoles = lodash
        .filter(existingRoles, role => role.isSystem === false)
        .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
    const systemRoles = lodash
        .filter(existingRoles, role => role.isSystem === true)
        .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
    const newDoaRoles = lodash.concat(systemRoles, nonSystemRoles);

    return {
        ...state,
        doaRoles: lodash.cloneDeep(newDoaRoles),
    };
}

export default composeReducers(
    loadStudyRoles,
    addStudyRole,
);